<template>
    <tr>
        <td>{{ livro.ano }}</td>
        <td>{{ `${livro.mes}`.padStart(2, "0") }}</td>
        <td align="center">
            <button class="default-button" disabled v-if="visualizando">
                GERANDO ({{ Math.round(percentual) }}%)
            </button>
            <button class="default-button" @click="visualizar" v-else>
                VISUALIZAR
            </button>
            <button class="default-button" v-if="imprimindo" disabled>
                GERANDO ({{ Math.round(percentual) }}%)
            </button>
            <button class="default-button visible-md" v-else @click="imprimir">
                IMPRIMIR
            </button>
            <PdfViewer :url="url" v-if="show_impressao" @close="hideImpressao"></PdfViewer>
            <!--

                <FlipBook
                :documentos="documentos"
                v-if="show_flip_book"
                @close="hideFlipBook"
                ></FlipBook>
            -->
            <Visualizador v-if="show_flip_book" @close="hideFlipBook" :livro="livro" :codigo_condominio="codigo_condominio"
                :codigo_livro_digital="codigo_livro_digital" :id_docsprime="id_docsprime"></Visualizador>
        </td>
    </tr>
</template>
<script>

import Visualizador from './visualizador.vue'
import { getDocumentos, getDocumento as getArquivos } from '../../../store/livro-digital/documentos-repository'
//import api from "/plugins/api";
//import { pdf2jpeg } from "/plugins/pdf";
//import { pdf2jpeg } from '/plugins/pdf';
//import jsPDF from "jspdf";
import FlipBook from "./flip-book.vue";
import PdfViewer from "./pdf-viewer.vue";
export default {
    props: ["livro"],
    components: {
        FlipBook,
        PdfViewer,
        Visualizador
    },
    data() {
        return {
            visualizando: false,
            imprimindo: false,
            gerando: false,
            errors: [],
            documentos: null,
            show_flip_book: false,
            percentual: 0,
            url: null,
            show_impressao: false
        };
    },
    computed: {
        condominio() {
            return this.$store.getters.condominio;
        },
        codigo_condominio() {
            if (!this.condominio) {
                return null;
            }
            return this.condominio.codigo;
        },
        codigo_livro_digital() {
            return this.livro.CodLivroDigital;
        },
        id_docsprime() {
            return this.livro.IdDocsprime;
        },
        data_inicio() {
            let mes = this.livro.mes < 10 ? `0${this.livro.mes}` : this.livro.mes
            return `${this.livro.ano}-${mes}-01`
        },
        data_fim() {
            let mes = this.livro.mes < 10 ? `0${this.livro.mes}` : this.livro.mes
            return `${this.livro.ano}-${mes}-31`
        },
    },
    methods: {
        showFlipBook() {
            this.show_flip_book = true;
        },
        hideFlipBook() {
            this.show_flip_book = false;
        },
        async gerarDocumentos() {
            if (this.gerando) {

                return;
            }
            if (this.documentos) {

                return;
            }


            let documentos = await getDocumentos({
                codigo_condominio: this.codigo_condominio,
                codigo_livro_digital: this.codigo_livro_digital,
                id_docsprime: this.id_docsprime,
            })

            /*
            let { data: documentos } = await api.get(
                `condominios/${this.codigo_condominio}/livro-digital/${this.codigo_livro_digital}/${this.id_docsprime}/documentos`
            );
            */



            this.percentual = 0;
            documentos = await Promise.all(
                documentos.map(async (documento) => {
                    let Arquivos = [];
                    try {
                        let arquivos = await getArquivos({
                            codigo_condominio: this.codigo_condominio,
                            IdDocsprime: documento.IdDocsprime
                        })

                        /*
                        let { data: arquivos } = await api.get(
                            `condominios/${this.codigo_condominio}/livro-digital/${documento.IdDocsprime}/arquivos`
                        );
                        */
                        //arquivos = await Promise.all(arquivos.map(({ imagens }) => imagens));
                        
                        /*
                        arquivos = await Promise.all(
                            arquivos.map(({ conteudoBase64: conteudo }) =>
                                pdf2jpeg(conteudo)
                            )
                        );
                        
                        
                        
                        arquivos = arquivos.reduce(
                            (acc, imagens) => [...acc, ...imagens],
                            []
                        );
                        */

                        Arquivos = arquivos;
                        
                    } catch (err) {
                        console.error(err);
                    }

                    this.percentual += 100 / documentos.length;
                    
                    return {
                        ...documento,
                        arquivos: Arquivos,
                    };
                })
            );
            
            this.documentos = documentos;
            this.gerando = false;
        },
        async visualizar() {
            try {
                if (this.visualizando) {
                    return;
                }
                this.visualizando = true;
                //await this.gerarDocumentos();
                this.showFlipBook();
            } catch (err) {
                console.error(err);
                this.errors = [...this.errors, err];
            }
            this.visualizando = false;
        },
        async gerarPdf() {
            try {
                if (this.url) {
                    return;
                }
                await this.gerarDocumentos();

                const jsPDF = await import('jspdf').then(e => e.jsPDF)

                let doc = new jsPDF({
                    orientation: "p",
                    unit: "mm",
                    format: "a4",
                });
                doc.deletePage(1);
                for (let documento of this.documentos) {
                    for (let arquivo of documento.arquivos) {
                        
                        let img = await new Promise((resolve, reject) => {
                            let img = new Image();
                            img.onload = () => resolve(img),
                                img.onerror = reject;
                            img.src = arquivo;
                        });
                        let w = (img.width * 25) / 72;
                        let h = (img.height * 25) / 72;

                        doc.addPage([Math.ceil(w), Math.ceil(h)]);
                        doc.addImage(arquivo, "JPEG", 0, 0, w, h);

                    }
                }
                let url = doc.output('bloburi');
                
                this.url = url;
            } catch (err) {
                console.error(err);
            }

        },
        async imprimir() {
            try {
                if (this.imprimindo) {

                    return false;
                }
                this.imprimindo = true;
                await this.gerarPdf();
                this.showImpressao();
            } catch (err) {
                console.error(err);
            }
            this.imprimindo = false;
        },
        showImpressao() {
            this.show_impressao = true;
        },
        hideImpressao() {
            this.show_impressao = false;
        },
    }
};
</script>